import { permissionMenu, menuMap, menuBackoffice } from '../constant/Constant'

const utmObj = require('utm-latlng')

export const convertObjectName = (itemTH: string, itemEN: string) => {
    return {
        th: itemTH,
        en: itemEN,
    }
}

export type TAddressData = {
    addressTH?: string
    addressEN?: string
    subDistrictNameTH?: string
    subDistrictNameEN?: string
    districtNameTH?: string
    districtNameEN?: string
    provinceID?: string
    provinceNameTH?: string
    provinceNameEN?: string
    postcode?: string
}

export const formatAddress = (addressData: TAddressData) => {
    const {
        addressTH,
        addressEN,
        subDistrictNameTH,
        subDistrictNameEN,
        districtNameTH,
        districtNameEN,
        provinceID,
        provinceNameTH,
        provinceNameEN,
        postcode,
    } = addressData

    // return `${address}, ${tamName} Subdistrict, ${ampName} District, ${provName} ${postCode}`
    let AddressEN = ``
    if (addressEN) AddressEN += `${addressEN.trim()},`
    if (subDistrictNameEN) AddressEN += ` ${subDistrictNameEN.trim()} Subdistrict,`
    if (districtNameEN) AddressEN += ` ${districtNameEN.trim()} District,`
    if (provinceNameEN) AddressEN += ` ${provinceNameEN.trim()}`
    if (postcode) AddressEN += ` ${postcode.trim()}`

    // return `${address} ตำบล${tamName} อำเภอ${ampName} จังหวัด${provName} ${postCode}`
    const isBKK = Boolean(parseInt(provinceID || '') === 10)
    let AddressTH = ``
    if (addressTH) AddressTH += `${addressTH.trim()}`
    if (subDistrictNameTH) AddressTH += isBKK ? ` แขวง${subDistrictNameTH.trim()}` : ` ตำบล${subDistrictNameTH.trim()}`
    if (districtNameTH) AddressTH += isBKK ? ` เขต${districtNameTH.trim()}` : ` อำเภอ${districtNameTH.trim()}`
    if (provinceNameTH) AddressTH += isBKK ? ` ${provinceNameTH.trim()}` : ` จังหวัด${provinceNameTH.trim()}`
    if (postcode) AddressTH += ` ${postcode.trim()}`

    return convertObjectName(AddressTH.trim(), AddressEN.trim())
}

export const formatTelephone = (telephone: string) => {
    let cleaned = ('' + telephone).replace(/\D/g, '')

    let match
    if (cleaned.length > 9) {
        match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
    } else if (cleaned.length === 9 && cleaned.slice(0, 2) === '02') {
        match = cleaned.match(/^(\d{2})(\d{3})(\d{4})$/)
    } else if (cleaned.length <= 9) {
        match = cleaned.match(/^(\d{3})(\d{3})(\d{3})$/)
    }

    if (match) {
        return [match[1], '-', match[2], '-', match[3]].join('')
    }
    return null
}

export const formatTelephoneNumberOnly = (telephone: string) => {
    return telephone.split('-').join('')
}

export type TContactData = {
    contactNameTH?: string
    contactNameEN?: string
    contactPositionNameTH?: string
    contactPositionNameEN?: string
    telephone?: string
}

export const formatContact = (contactData: TContactData) => {
    const { contactNameTH, contactNameEN, contactPositionNameTH, contactPositionNameEN, telephone } = contactData
    // return `${contactName} (${contactPositionName}) ${telephone}`

    let tel = telephone ? formatTelephone(telephone.trim()) : null

    let contactEN = ``
    if (contactNameEN) contactEN += `${contactNameEN.trim()}`
    if (contactPositionNameEN) contactEN += ` (${contactPositionNameEN.trim()})`
    if (tel) contactEN += ` ${tel}`

    let contactTH = ``
    if (contactNameTH) contactTH += `${contactNameTH.trim()}`
    if (contactPositionNameEN) contactTH += ` (${contactPositionNameTH?.trim()})`
    if (tel) contactTH += ` ${tel}`

    return convertObjectName(contactTH, contactEN)
}

export const calculateMidFrequency = (frequency: number) => {
    return (frequency - 21) * 8 + 474
}

export const convertUTMToLonLat = (east: number, north: number, zone: number = 47, hemisphere: 'S' | 'N' = 'N') => {
    // UTM : Universal Transverse Mercator
    // x = 1550754.429849245
    // y = 11090095.559836734

    const utm = new utmObj()
    const { lng, lat } = utm.convertUtmToLatLng(east, north, zone, hemisphere)
    return { longitude: lng, latitude: lat }
}

export const convertDMSToLonLat = (x: string, y: string) => {
    // DMS : Degrees Minutes Seconds
    // x = 13°41'29.559
    // y = 100°32'6.392

    const xD = parseFloat(x.split('°')[0])
    const xM = parseFloat(x.split('°')[1].split("'")[0]) / 60
    const xS = parseFloat(x.split('°')[1].split("'")[1].split('"')[0]) / 3600
    const longitude = xD + xM + xS

    const yD = parseFloat(y.split('°')[0])
    const yM = parseFloat(y.split('°')[1].split("'")[0]) / 60
    const yS = parseFloat(y.split('°')[1].split("'")[1].split('"')[0]) / 3600
    const latitude = yD + yM + yS

    return { longitude, latitude }
}

export const separateWordCommaLonLat = (value: string) => {
    const word = value.split(',').map((item) => Number(item.trim()))
    return {
        longitude: word[1],
        latitude: word[0],
    }
}

export const separateWordCommaDMS = (value: string) => {
    const word = value.split(',')
    return {
        x: word[1],
        y: word[0],
    }
}

export const getDomainOfUrl = (url: string) => {
    return `${url.replace('https://', '').replace('www.', '').split('/')?.[0]}/${
        url.replace('https://', '').replace('www.', '').split('/')?.[1]
    }`
}

export const getUrl = (url: string) => {
    if (!url) return '#'
    return url.indexOf('http') !== -1 ? url : `https://${url}`
}

export const getAttachmentIcon = (url: string) => {
    const docImg = `${process.env.REACT_APP_IMAGE_PATH}/assets/image/icon_doc.png`
    const docxImg = `${process.env.REACT_APP_IMAGE_PATH}/assets/image/icon_docx.png`
    const pdfImg = `${process.env.REACT_APP_IMAGE_PATH}/assets/image/icon_pdf.png`
    const xlsxImg = `${process.env.REACT_APP_IMAGE_PATH}/assets/image/icon_xlsx.png`

    const extension = url.split('.').pop()
    if (extension === 'jpg' || extension === 'png' || extension === 'jpeg') return url
    else if (extension === 'pdf') return pdfImg
    else if (extension === 'xlsx') return xlsxImg
    else if (extension === 'docx') return docxImg
    else return docImg
}

export const getErrorMessageByStatusCode = (errMsg: string, functionName?: string) => {
    if (errMsg.includes('400')) return 'ไม่พบข้อมูล'
    else if (errMsg.includes('401')) return `คุณไม่สามารถใช้งานฟังก์ชัน${functionName}ได้`
    else if (errMsg.includes('403')) return `คุณไม่ได้รับสิทธิ์เข้าถึงฟังก์ชัน${functionName}`
    else if (errMsg.includes('404')) return 'ไม่พบข้อมูล'
    else if (errMsg.includes('500')) return 'เกิดข้อผิดพลาดภายในระบบ'
    else if (errMsg.includes('503')) return 'ระบบปิดปรับปรุงชั่วคราว'
    else return 'เกิดข้อผิดพลาด'
}

const getSubMenuPath = (menuId: number, subMenu: any[], userPermission: string[]) => {
    let path = subMenu.filter(
        (item) =>
            item.id ===
            permissionMenu
                ?.filter((item: PermissionMenuType) => userPermission.includes(item.permissionId))
                ?.flatMap((item: PermissionMenuType) => item.menuAllowed)
                ?.filter((item: number) => Math.floor(item) === menuId)
                ?.filter((v, i, a) => a.indexOf(v) === i)?.[0],
    )?.[0]?.path

    return path
}

export const getMapMenuByPermission = (userPermission: string[]) => {
    if (userPermission?.length > 0) {
        let filterPermissionMenu = permissionMenu
            ?.filter((item: PermissionMenuType) => userPermission.includes(item.permissionId))
            ?.flatMap((item: PermissionMenuType) => item.menuAllowed)
            ?.map((item: number) => Math.floor(item))
            ?.filter((v, i, a) => a.indexOf(v) === i)

        let menu = menuMap.map((item: MapMenuType) => ({
            ...item,
            path: item.id != 7 ? item.path : getSubMenuPath(item.id, menuBackoffice, userPermission),
            display: item.display ? true : filterPermissionMenu.includes(item.id) ? true : false,
        }))

        return menu
    } else return menuMap
}

export const getBackofficeMenuByPermission = (userPermission: string[]) => {
    if (userPermission?.length > 0) {
        let filterPermissionMenu = permissionMenu
            ?.filter((item: PermissionMenuType) => userPermission.includes(item.permissionId))
            ?.flatMap((item: PermissionMenuType) => item.menuAllowed)
            ?.filter((v, i, a) => a.indexOf(v) === i)

        let menu = menuBackoffice.map((item: BackofficeMenuType) => ({
            ...item,
            display: item.display ? true : filterPermissionMenu.includes(item.id) ? true : false,
        }))

        return menu
    } else return menuBackoffice
}

export const generateRefCode = (length: number) => {
    // const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' // Generate RefCode Upper Character only
    const charactersLength = characters.length
    let result = ''
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
}

export const getDecimalBySpecificDigit = (decimal: number = 0, digit: number = 5) => {
    const digitString = decimal.toString().includes('.') ? decimal.toString().split('.').pop() : ''
    //@ts-ignore
    return digitString.length > digit ? decimal.toFixed(digit) : decimal
}
